import React from 'react';
import useStyles from './Styles';
import { Box } from '@material-ui/core';
import toggleIcon from "../../assets/slide-out-icon.png";
import AboutSidebar from './AboutSidebar';

const AboutTogglebar = () => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);

    return (
        <>
            {
                !open ? (
                    <Box className={classes.aboutTogglebar} onClick={ () => setOpen(!open) }>
                        <img src={toggleIcon} className={classes.aboutToggleIcon} alt="about-toggle.png" />
                    </Box>
                ) : (
                    <Box className={classes.aboutDrawer}>
                        <AboutSidebar onClose={() => setOpen(false)} />
                    </Box>
                )
            }
        </>
    );
};

export default AboutTogglebar;